import { css } from '@emotion/core'
import { smallOnly } from 'Utils'
import theme from 'Theme'

const { colors, layout, mixins } = theme

export default () => css`
  background-color: ${colors.white};
  overflow: auto;

  .heading-load {
    height: 116px;
    margin: 20px auto;
    width: 95%;
    max-width: 700px;
    ${mixins.loadingBackground(
      colors.loading.panel.light.backgroundColor,
      colors.white
    )}
  }

  .product-list-wrapper {
    width: 100%;
    max-width: ${layout.maxWidth.mainContainer}px;
    margin: auto;
  }

  .product-list-loading {
    height: 400px;
    ${mixins.loadingBackground(
      colors.loading.panel.light.backgroundColor,
      colors.white
    )}

    @media ${smallOnly} {
      width: 100%;
      height: 250px;
    }
  }
`
